import { Link } from 'react-router-dom';
import { SearchXIcon } from 'lucide-react';

import { StateBlock } from '@/components/StateBlock';
import { Button } from '@/components/ui/button';

/**
 * One screen for "no such page" and "no such project".
 *
 * Plan 4.4: a missing resource and another tenant's resource are the same
 * answer, because a 403 would confirm that the resource exists and turn id
 * enumeration into an existence oracle. The wording here says the true thing
 * without distinguishing the two cases.
 */
export function NotFound() {
  return (
    <div className="zs-dark-surface m-4 flex min-h-[60vh] items-center justify-center rounded-[40px]">
      <StateBlock
        icon={SearchXIcon}
        title="Not found"
        detail="This page does not exist, or it belongs to an organisation you are not a member of."
        action={
          <Button asChild size="sm" variant="outline">
            <Link to="/">Back to your workspace</Link>
          </Button>
        }
      />
    </div>
  );
}
